export type AnalyticsEventName =
  | "phone_click"
  | "email_click"
  | "directions_click"
  | "social_click"
  | "form_start"
  | "form_success";

declare global {
  interface Window {
    umami?: { track: (name: string, data?: Record<string, string>) => void };
    __CORE_ANALYTICS_LISTENER__?: boolean;
  }
}

export function trackEvent(name: AnalyticsEventName, data?: Record<string, string>) {
  if (typeof window === "undefined") return;
  window.umami?.track(name, data);
}

export function classifyLinkEvent(anchor: HTMLAnchorElement) {
  const href = anchor.getAttribute("href") || "";
  if (href.startsWith("tel:")) return { name: "phone_click" as const };
  if (href.startsWith("mailto:")) return { name: "email_click" as const };
  if (/google\.(com|maps)|maps\.app\.goo\.gl/i.test(href)) return { name: "directions_click" as const };
  if (/facebook\.com|instagram\.com|linkedin\.com/i.test(href)) {
    const platform = href.match(/facebook|instagram|linkedin/i)?.[0]?.toLowerCase() || "social";
    return { name: "social_click" as const, data: { platform } };
  }
  return null;
}

export function initializeLinkAnalytics() {
  if (typeof window === "undefined" || window.__CORE_ANALYTICS_LISTENER__) return;
  window.__CORE_ANALYTICS_LISTENER__ = true;
  document.addEventListener("click", (event) => {
    const target = event.target instanceof Element ? event.target.closest("a") : null;
    if (!(target instanceof HTMLAnchorElement)) return;
    const classified = classifyLinkEvent(target);
    if (classified) trackEvent(classified.name, classified.data);
  });
}
